module.exports = __webpack_public_path__ + "img/fourday1-1.24c404e4.jpg";